/**
 * @file preview-config-context.tsx
 * @description Контекст preview-конфига конструктора (phase19.8.2):
 * webBaseUrl нужен полям форм (превью картинок — относительные пути
 * `/images/…`, `/api/…` являются ресурсами apps/web).
 */

import { createContext, useContext, type ReactNode } from "react";

import type { SitePreviewConfig } from "../../lib/api-site-pages";

const PreviewConfigContext = createContext<SitePreviewConfig | null>(null);

export function PreviewConfigProvider({
  value,
  children,
}: {
  value: SitePreviewConfig | null;
  children: ReactNode;
}) {
  return (
    <PreviewConfigContext.Provider value={value}>{children}</PreviewConfigContext.Provider>
  );
}

export function usePreviewConfig(): SitePreviewConfig | null {
  return useContext(PreviewConfigContext);
}

/** Абсолютный URL web-ресурса; null — нельзя показать (нет webBaseUrl). */
export function resolveWebAssetUrl(
  url: string | null | undefined,
  config: SitePreviewConfig | null,
): string | null {
  if (!url) return null;
  if (/^https?:\/\//.test(url)) return url;
  const base = config?.webBaseUrl;
  return base ? `${base.replace(/\/+$/, "")}${url}` : null;
}
